export enum CurrencyType {
  COP = 'COP',
  USD = 'USD',
}

export type CurrencyTypeOption = {
  format: string;
  symbol: string;
  requiresDecimal: boolean;
}

export const CURRENCY_TYPES = new Map<CurrencyType, CurrencyTypeOption>([
  [CurrencyType.COP, { format: '2.0-0', symbol: 'COP ', requiresDecimal: false }],
  [CurrencyType.USD, { format: '1.2-2', symbol: 'USD ', requiresDecimal: true }],
]);

export const DEFAULT_CURRENCY_FORMAT = '2.0-0';

export function getCurrencyType(currencyCode: string): CurrencyType {
  return CurrencyType[currencyCode as keyof typeof CurrencyType];
}